import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TN3224Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TN3224IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_553)">
        <rect width="32" height="24" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V24H32V0H0Z"
          fill="#E31D1C"
        />
        <mask
          id="mask0_1813_553"
          mask-type="luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="24"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H32V0H0Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_1813_553)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 20C20.4183 20 24 16.4183 24 12C24 7.58172 20.4183 4 16 4C11.5817 4 8 7.58172 8 12C8 16.4183 11.5817 20 16 20Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4025 17.6507C17.4025 17.6507 13.1861 16.5003 13.1861 11.9734C13.1861 7.44637 17.4025 6.19744 17.4025 6.19744C15.659 5.52264 10.5567 6.55802 10.5567 11.9734C10.5567 17.3887 15.8014 18.364 17.4025 17.6507ZM17.1704 10.9883L15.0785 11.7526L17.3268 12.5385L17.4025 14.6434L18.7708 13.0081L21.0269 13.1683L19.4014 11.8421L20.3803 9.92702L18.4681 10.5707L17.1433 8.91475L17.1704 10.9883Z"
            fill="#E31D1C"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1813_553">
          <rect width="32" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TN3224Icon;
